import { useRef, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useApp } from '../context.jsx';

// Маршруты в порядке навигации. title — ключ в translations (будет добавлен).
const ROUTES = [
  { to: '/artworks',       key: 'artworks' },
  { to: '/constellation',  key: 'constellation' },
  { to: '/lab',            key: 'lab' },
  { to: '/prints',         key: 'prints' },
  { to: '/workshops',      key: 'workshops' },
  { to: '/custom',         key: 'custom' },
  { to: '/collaborations', key: 'collabs' },
  { to: '/about',          key: 'about' },
  { to: '/blog',           key: 'blog' },
  { to: '/contact',        key: 'contact' },
];

export default function Nav() {
  const { lang, setLang, t, CH, CL } = useApp();
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();

  useEffect(() => setMenuOpen(false), [location.pathname]);

  useEffect(() => {
    const onScroll = () => {
      const sy = window.scrollY;
      if (!navRef.current) return;
      const o = Math.min(sy / 150, 0.9);
      navRef.current.style.background = `rgba(3,3,3,${o})`;
      navRef.current.style.backdropFilter = sy > 80 ? 'blur(24px)' : 'none';
      navRef.current.style.borderBottom = `1px solid rgba(196,148,74,${Math.min(sy / 300, 0.06)})`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const labels = t.nav2 || {};

  return (
    <>
      <nav ref={navRef} className="N" role="navigation" aria-label={lang === 'ru' ? 'Основная навигация' : 'Main navigation'}>
        <div className="N-i">
          <NavLink to="/" className="N-logo" onMouseEnter={CH} onMouseLeave={CL}>
            {lang === 'ru' ? 'Е. Федькина' : 'E. Fedkina'}
          </NavLink>
          <ul className="N-links">
            {ROUTES.map((r) => (
              <li key={r.to}>
                <NavLink
                  to={r.to}
                  className={({ isActive }) => `N-a ${isActive ? 'on' : ''}`}
                  onMouseEnter={CH}
                  onMouseLeave={CL}
                >
                  {labels[r.key] || r.key}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="N-r">
            <button className="N-lang" onClick={() => setLang(lang === 'ru' ? 'en' : 'ru')} onMouseEnter={CH} onMouseLeave={CL}>
              {lang === 'ru' ? 'EN' : 'RU'}
            </button>
            <button className="N-ham" onClick={() => setMenuOpen(true)} aria-label={lang === 'ru' ? 'Открыть меню' : 'Open menu'}>
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      <div className={`MM ${menuOpen ? 'open' : ''}`} role="dialog" aria-modal="true" aria-label={lang === 'ru' ? 'Меню навигации' : 'Navigation menu'}>
        <button style={{ position: 'absolute', top: 20, right: 28, fontSize: 28, color: 'var(--td)' }} onClick={() => setMenuOpen(false)} aria-label="Close">✕</button>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>{lang === 'ru' ? 'Главная' : 'Home'}</NavLink>
        {ROUTES.map((r) => (
          <NavLink key={r.to} to={r.to} onClick={() => setMenuOpen(false)}>{labels[r.key] || r.key}</NavLink>
        ))}
        <button onClick={() => { setLang(lang === 'ru' ? 'en' : 'ru'); setMenuOpen(false); }} style={{ color: 'var(--g)', fontSize: 22 }}>
          {lang === 'ru' ? 'English' : 'Русский'}
        </button>
      </div>
    </>
  );
}
